import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import ImageCarousel from '@hpstellar/core/ProductTile/components/ImageCarousel';
import { Violator } from '@hpstellar/core/visId';

import { mapBundleProducts, getHeaderProps } from '../../../product/get-product-props';
import { useGetProductPrice } from '../../../hooks/useProductPrice';
import { getImages } from '../../../product/get-product-props/store-app-product';
import SaleCallout from '../sale-callout';

export default ({ product, onClick }) => {
    const priceObj = useGetProductPrice(product, { useSubscriptionsPromo: true });
    const { headerProps } = getHeaderProps(product, priceObj, { combineBadges: false, noViolator: true });
    const { customElement, offerMessage } = headerProps || {};
    const { customContent, sustainability } = customElement || {};
    const hasOverlay = !!sustainability;
    const className = `prod-img${hasOverlay ? ' with-overlay' : ''}`;
    const carouselProps = {
        prevArrowClassName: 'prev-img',
        nextArrowClassName: 'next-img',
    };

    const clickHandler = useCallback(
        e => {
            if (onClick && e.target.tagName === 'IMG') {
                onClick();
            }
        },
        [onClick],
    );

    return (
        <div className={className} onClick={clickHandler}>
            <div className="offer-overlay">
                <SaleCallout product={product} />
                {sustainability}
            </div>
            <ImageCarousel images={getImages(product)} {...carouselProps} />
        </div>
    );
};
